var map = {
	"./admin.js": "yTZE",
	"./auth.js": "hF7s",
	"./check-auth.js": "/uKq",
	"./guest.js": "8jA6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "C/Wi";


//////////////////
// WEBPACK FOOTER
// ./src/middleware nonrecursive .*\.js$
// module id = C/Wi
// module chunks = 6